/* eslint-disable max-len */
import React from 'react'
import { PriceHandler } from '../../../redux/helper/CamelCase'
import { GenerateDateandTime, GenerateDateFormat, generateDateWithTime } from '../../../redux/helper/DateConverter'
import { Link } from 'react-router-dom';


const RecentOrders = ({recentOrders,setRecentOrders}) => {
    const order_Status={
        1:'Pending',
        2:'In-process',
        3:'Approved',
        4:'Out for delivery',
        5:'Partially delivered',
        6:'Deliverd',
        7:'Completed',
        8:'Cancelled'
    }

    const payment_type={
        0:'On Credit',
        1:'Advanced Payment'
    }

    return (
        <div className="sm:px-5 px-3 sm:py-5 py-3 mt-[13px] bg-[#F5F5FA] rounded-lg">
            <div className=" text-start ">
                <p className="sm:text-xs10 text-lg font-semibold text-[#090406]">Your Recent Orders</p>
            </div>
            <div className="overflow-auto dropdown-menu pt-[18px] pb-7 relative z-[6]">
                
                <table className="w-full table-auto relative">
                    <thead>
                        <tr className="bg-[#555259] h-10">
                            <th className="py-2.5 px-6 rounded-bl-lg rounded-tl-lg min-w-[171px] sticky top-0 left-0 bg-[#555259]" scope="col">
                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                    Order Number
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[175px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                    Order Created
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[168px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                    Indent Number
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[177px] text-center flex justify-center items-center">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                    Order Type
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[152px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    No. of Items
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[165px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                    Order Status
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[152px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                    Total Amount
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[160px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                    Payment Type
                                </span>
                            </th>
                            {/* <th scope="col" className="py-2.5 px-7 min-w-[152px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                    Payment Due
                                </span>
                            </th>
                            <th scope="col" className="py-2.5 px-7 min-w-[208px]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                    Expected Dispatch
                                </span>
                            </th> */}
                            <th scope="col" className="py-2.5 px-7 min-w-[152px] rounded-tr-lg rounded-br-lg sm:sticky top-0 right-0 bg-[#555259]">
                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                    Actions
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {recentOrders.length > 0 && recentOrders.map((order, idx) => (
                            <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]" key={`recent-order-${idx}`}>
                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7 sticky left-0 flex justify-center items-center pt-4" style={{
                                    background: "rgba(255, 255, 255, 0.45)",
                                    backdropFilter: "blur(5.5px)"
                                }}>
                                    {order?.order_initial_number}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                    {generateDateWithTime(order?.created_at)}
                                </td>
                                <td className="text-sm font-normal text-[#090406] text-center py-2.5 px-7">
                                    {order?.order_number}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                    {order?.order_type}
                                </td>
                                <td className="text-sm font-normal py-2.5 px-7 text-center">
                                    {order?.total_items}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                    {order_Status[String(order?.status)]}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                    {PriceHandler(order?.total_price)}

                                </td>
                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                    {payment_type[(order?.payment_type)]}
                                </td>
                                {/* <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                    20/09/2022
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                    20/09/2022
                                </td> */}
                                <td className="py-2.5 px-7 sm:sticky right-0 z-50" style={{
                                    background: "rgba(255, 255, 255, 0.45)",
                                    backdropFilter: "blur(5.5px)"
                                }}>
                                    <div className="flex items-center">
                                        <Link to={`/orders/${order.order_number}/view`}>
                                            <button type="button" className="font-semibold text-sm text-[#303030] bg-[#A5A5A5] rounded-lg w-[72px] h-[34px]">
                                                View
                                            </button>
                                        </Link>
                                    </div>
                                </td>
                            </tr>                         
                        ))}
                    </tbody>
                </table>

               
            </div>
            <div className="w-full bg-white rounded-[8px] flex justify-center mt-5 shadow-7s">
                <Link to={"/orders"}>
                    <button className="text-sm55 py-5 text-center  font-normal text-black">View All
                    </button> 
                </Link>
            </div>
        </div> 
    )
}

export default RecentOrders
